import {deviceService} from 'interactors/deviceProxy';

export const listenersList: Listeners = [deviceService];
